export const stateList = [
  {
    label: 'ACT',
    value: 'ACT',
  },
  {
    label: 'NSW',
    value: 'NSW',
  },
  {
    label: 'NT',
    value: 'NT',
  },
  {
    label: 'QLD',
    value: 'QLD',
  },
  {
    label: 'SA',
    value: 'SA',
  },
  {
    label: 'TAS',
    value: 'TAS',
  },
  {
    label: 'VIC',
    value: 'VIC',
  },
  {
    label: 'WA',
    value: 'WA',
  },
]

export const cardTypes = [
  {
    label: 'Visa',
    value: 'visa',
  },
  {
    label: 'Mastercard',
    value: 'mastercard',
  },
  {
    label: 'American Express',
    value: 'amex',
  },
]
